import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["rowspan"]
const _hoisted_2 = ["name", "id"]
const _hoisted_3 = ["rowspan"]
const _hoisted_4 = { stakeholder: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Highlighter = _resolveComponent("Highlighter")!
  const _component_Acceptability = _resolveComponent("Acceptability")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aimItems, (aimItem, aimIndex) => {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqBy(
            _ctx.filterItemsBy(_ctx.items, {
              aim: aimItem.aim
            }),
            'stakeholder'
          ), (stakeholderItem, stakeholderIndex) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: `stakeholder-${stakeholderIndex}-${aimIndex}`
        }, [
          (aimIndex === 0 && stakeholderIndex === 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                criterion: "",
                rowspan: _ctx.uniqBy(
            _ctx.filterItemsBy(_ctx.items, {
              criterion: aimItem.criterion
            }),
            'stakeholder'
          ).length * _ctx.aimItems.length
              }, [
                _createElementVNode("a", {
                  name: `${_ctx.property}`,
                  id: _ctx.property
                }, null, 8, _hoisted_2),
                _createVNode(_component_Highlighter, {
                  class: "inline-block",
                  searchWords: [_ctx.state.searchInput],
                  "text-to-highlight": _ctx.property
                }, null, 8, ["searchWords", "text-to-highlight"])
              ], 8, _hoisted_1))
            : _createCommentVNode("", true),
          (stakeholderIndex === 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 1,
                aim: "",
                rowspan: _ctx.uniqBy(
            _ctx.filterItemsBy(_ctx.items, {
              aim: aimItem.aim
            }),
            'stakeholder'
          ).length
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getAimById(aimItem.aim).name), 1)
              ], 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("td", _hoisted_4, [
            _createElementVNode("b", null, _toDisplayString(_ctx.getStakeholderName(stakeholderItem.stakeholder)), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.c_alternativesIds, (alternativeId, alternativeIndex) => {
            return (_openBlock(), _createElementBlock("td", {
              class: "text-center",
              alternative: "",
              key: alternativeIndex
            }, [
              _createVNode(_component_Acceptability, {
                items: 
              _ctx.filterItemsBy(_ctx.items, {
                alternative: alternativeId,
                aim: aimItem.aim,
                stakeholder: stakeholderItem.stakeholder
              })
            ,
                alternative: alternativeId,
                icon: false
              }, null, 8, ["items", "alternative"])
            ]))
          }), 128))
        ]))
      }), 128))
    ], 64))
  }), 256))
}